(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.TDesignIconReact = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var classnames = {exports: {}};

  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  (function (module) {
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames() {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg)) {
  				if (arg.length) {
  					var inner = classNames.apply(null, arg);
  					if (inner) {
  						classes.push(inner);
  					}
  				}
  			} else if (argType === 'object') {
  				if (arg.toString === Object.prototype.toString) {
  					for (var key in arg) {
  						if (hasOwn.call(arg, key) && arg[key]) {
  							classes.push(key);
  						}
  					}
  				} else {
  					classes.push(arg.toString());
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if (module.exports) {
  		classNames.default = classNames;
  		module.exports = classNames;
  	} else {
  		window.classNames = classNames;
  	}
  }());
  }(classnames));

  var classNames = classnames.exports;

  var DEFAULT_CLASS_PREFIX = "t";
  var DEFAULT_LOCALE = "zh-CN";
  var ConfigContext = /*#__PURE__*/React.createContext({
    classPrefix: DEFAULT_CLASS_PREFIX,
    locale: DEFAULT_LOCALE
  });
  var ConfigContext$1 = ConfigContext;

  var useConfig = (function () {
    return React.useContext(ConfigContext$1);
  });

  function useCommonClassName() {
    var _useConfig = useConfig(),
        classPrefix = _useConfig.classPrefix;

    return React.useMemo(function () {
      return {
        SIZE: {
          "default": "",
          xs: "".concat(classPrefix, "-size-xs"),
          small: "".concat(classPrefix, "-size-s"),
          middle: "".concat(classPrefix, "-size-m"),
          large: "".concat(classPrefix, "-size-l"),
          xl: "".concat(classPrefix, "-size-xl"),
          block: "".concat(classPrefix, "-size-full-width")
        },
        STATUS: {
          loading: "".concat(classPrefix, "-is-loading"),
          disabled: "".concat(classPrefix, "-is-disabled"),
          focused: "".concat(classPrefix, "-is-focused"),
          success: "".concat(classPrefix, "-is-success"),
          error: "".concat(classPrefix, "-is-error"),
          warning: "".concat(classPrefix, "-is-warning"),
          selected: "".concat(classPrefix, "-is-selected"),
          active: "".concat(classPrefix, "-is-active"),
          checked: "".concat(classPrefix, "-is-checked"),
          current: "".concat(classPrefix, "-is-current"),
          hidden: "".concat(classPrefix, "-is-hidden"),
          visible: "".concat(classPrefix, "-is-visible"),
          expanded: "".concat(classPrefix, "-is-expanded"),
          indeterminate: "".concat(classPrefix, "-is-indeterminate")
        }
      };
    }, [classPrefix]);
  }

  function useSizeProps(size) {
    var COMMON_SIZE_CLASS_NAMES = useCommonClassName().SIZE;

    if (typeof size === "undefined") {
      return {};
    }

    if (!(size in COMMON_SIZE_CLASS_NAMES)) {
      return {
        className: "",
        style: {
          fontSize: size
        }
      };
    }

    return {
      className: COMMON_SIZE_CLASS_NAMES[size],
      style: {}
    };
  }

  var _excluded$3 = ["icon", "id", "className", "size", "style"];

  function ownKeys$1e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function render$1(node, id, rootProps) {
    return /*#__PURE__*/React.createElement(node.tag, _objectSpread$1e(_objectSpread$1e({
      key: id
    }, node.attrs), rootProps), (node.children || []).map(function (child, index) {
      return render$1(child, "".concat(id, "-").concat(node.tag, "-").concat(index));
    }));
  }

  var IconBase$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var icon = props.icon,
        id = props.id,
        className = props.className,
        size = props.size,
        style = props.style,
        restProps = _objectWithoutProperties(props, _excluded$3);

    var _useSizeProps = useSizeProps(size),
        sizeClassName = _useSizeProps.className,
        sizeStyle = _useSizeProps.style;

    var cls = classNames("t-icon", "t-icon-".concat(id), className, sizeClassName);
    return render$1(icon, "".concat(id), _objectSpread$1e({
      ref: ref,
      className: cls,
      style: _objectSpread$1e(_objectSpread$1e({}, style), sizeStyle)
    }, restProps));
  });
  IconBase$1.displayName = "TIconBase";

  function ownKeys$1d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$1a = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6 20V4h7v3c0 1.1.9 2 2 2h3v11H6zM17.17 7L15 4.83V7h2.17zM4 3a1 1 0 011-1h9.59a1 1 0 01.7.3l4.42 4.4a1 1 0 01.29.71V21a1 1 0 01-1 1H5a1 1 0 01-1-1V3zm12 8H8v2h8v-2zm-8 4h8v2H8v-2z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var AnalystReportIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$1d(_objectSpread$1d({}, props), {}, {
      id: "analyst_report",
      ref: ref,
      icon: element$1a
    }));
  });
  AnalystReportIcon.displayName = "AnalystReportIcon";
  var AnalystReportIcon$1 = AnalystReportIcon;

  function ownKeys$1c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$19 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M22 12a10 10 0 11-20 0 10 10 0 0120 0zm-7-4a3 3 0 11-6 0 3 3 0 016 0zm-3 5c-2.73 0-5.2 1.1-7 2.87a8 8 0 0014 0A9.97 9.97 0 0012 13z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var AvatarIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$1c(_objectSpread$1c({}, props), {}, {
      id: "avatar",
      ref: ref,
      icon: element$19
    }));
  });
  AvatarIcon.displayName = "AvatarIcon";
  var AvatarIcon$1 = AvatarIcon;

  function ownKeys$1b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$18 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M18 5H6v14h12V5zM6.17 4C5.52 4 5 4.45 5 5v14c0 .55.52 1 1.17 1h11.66c.65 0 1.17-.45 1.17-1V5c0-.55-.52-1-1.17-1H6.17z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 8,
        "height": 4,
        "x": 8,
        "y": 7,
        "fill": "currentColor",
        "rx": 0.5
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 8,
        "y": 12,
        "fill": "currentColor",
        "rx": 0.5
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 8,
        "y": 15,
        "fill": "currentColor",
        "rx": 0.5
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 11,
        "y": 12,
        "fill": "currentColor",
        "rx": 0.5
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 11,
        "y": 15,
        "fill": "currentColor",
        "rx": 0.5
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 5,
        "x": 14,
        "y": 12,
        "fill": "currentColor",
        "rx": 0.5
      }
    }]
  };
  var CalculatorIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$1b(_objectSpread$1b({}, props), {}, {
      id: "calculator",
      ref: ref,
      icon: element$18
    }));
  });
  CalculatorIcon.displayName = "CalculatorIcon";
  var CalculatorIcon$1 = CalculatorIcon;

  function ownKeys$1a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$17 = {
    "tag": "svg",
    "attrs": {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "viewBox": "0 0 26 27",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "url(#pattern0)",
        "d": "M4 0h22v27H4z"
      }
    }, {
      "tag": "defs",
      "attrs": {},
      "children": [{
        "tag": "pattern",
        "attrs": {
          "id": "pattern0",
          "width": 1,
          "height": 1,
          "patternContentUnits": "objectBoundingBox"
        },
        "children": [{
          "tag": "use",
          "attrs": {
            "transform": "scale(.04545 .03704)",
            "xlink:href": "#image0_1_3731"
          }
        }]
      }, {
        "tag": "image",
        "attrs": {
          "id": "image0_1_3731",
          "width": 22,
          "height": 27,
          "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAbCAYAAAB4Kn/lAAAAAXNSR0IArs4c6QAAAc5JREFUSA2llWlOw0AMhZmWTcBxKoo4BDfgjJyCH6AeB8RWGt5n7GiSTJpJa8myM2M/v/EsSU3TnPQlpbRhTHOr/lztd+oDAxpj8sG5zcA0VWCSBYR7Gs4ee+Fzv7JbitWA1wBfOfCP7Cfg0mH/PCjMHOAAhfmk1AA/OcqD7FJqjZ9Cnty82CvfyMBjQ2n1aEtqGAcYSOaryCuO7FqGwUGRBQGHiBd5Ue6ZdKkiC2nbJj42oXMLOPiz8jiSrB5sAzfGBKAUyME90YZyP49x/1r2Ugp7A+/02ME9dtwUinDWo630fLtQ0MrZjyNNz5wrhHbA2loSVdZHgoMDIGpnPYD1/S+FZcbUPsuGdTSA6cv9kaw7hXNgHpdZ4kQeS0kGrOXb7VHA3YGsI7+1wdjupIB3peoVYwCSy6p5/ZoWWB8IAVWse20gz34EbrvA3pK5rHO2MCa/6dw8DSAEci8xNZKzNWAIDt5jkARKi7j3vAE3Um4UB78ktIC/y5v0Xfoj3F2JseaMdWwG/zpAx1oEMDFtG+TbFcR2xJaSEkAkfElZ7j7G3x67I1d+GZgJCQGw+JCS2D9BGjKBQJwIA2V0rBXMEUQCifEOyB0IcblawB8b/ceCMFkocQAAAABJRU5ErkJggg=="
        }
      }]
    }]
  };
  var ClickIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$1a(_objectSpread$1a({}, props), {}, {
      id: "click",
      ref: ref,
      icon: element$17
    }));
  });
  ClickIcon.displayName = "ClickIcon";
  var ClickIcon$1 = ClickIcon;

  function ownKeys$19(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$19(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$19(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$19(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$16 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M10.61 11.97L5.3 17.3l1.42 1.42 5.32-5.32 5.31 5.31 1.36-1.36-5.31-5.31L18.7 6.7l-1.42-1.42-5.32 5.32L6.66 5.3 5.29 6.66l5.32 5.31z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var CloseIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$19(_objectSpread$19({}, props), {}, {
      id: "close",
      ref: ref,
      icon: element$16
    }));
  });
  CloseIcon.displayName = "CloseIcon";
  var CloseIcon$1 = CloseIcon;

  function ownKeys$18(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$18(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$18(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$18(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$15 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 11h4a1 1 0 011 1v3a1 1 0 01-1 1H6a2 2 0 01-2-2v-3zM15 12a1 1 0 011-1h4v5h-4a1 1 0 01-1-1v-3z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 3c4.42 0 8 3.53 8 7.88v3.37h-2.29V13h.39v-2.29C18.1 7.56 15.37 5 12 5c-3.37 0-6.1 2.56-6.1 5.71V13h.39v1.25H4v-3.38A7.94 7.94 0 0112 3z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M18.1 14.25H20v3.38A3.4 3.4 0 0116.57 21H12v-2h4.57c.63 0 1.53-.75 1.53-1.38v-3.37z"
      }
    }]
  };
  var ContactSalesIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$18(_objectSpread$18({}, props), {}, {
      id: "contact_sales",
      ref: ref,
      icon: element$15
    }));
  });
  ContactSalesIcon.displayName = "ContactSalesIcon";
  var ContactSalesIcon$1 = ContactSalesIcon;

  function ownKeys$17(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$17(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$17(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$17(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$14 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.05 15.05 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4a1 1 0 00-1-1H4a1 1 0 00-1 1 17 17 0 0017 17 1 1 0 001-1v-3.5a1 1 0 00-1-1zM19 12h2a9 9 0 00-9-9v2a7 7 0 017 7zm-4 0h2a5 5 0 00-5-5v2a3 3 0 013 3z"
      }
    }]
  };
  var ContactUsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$17(_objectSpread$17({}, props), {}, {
      id: "contact_us",
      ref: ref,
      icon: element$14
    }));
  });
  ContactUsIcon.displayName = "ContactUsIcon";
  var ContactUsIcon$1 = ContactUsIcon;

  function ownKeys$16(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$16(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$16(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$16(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$13 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4h16v16H4V4z",
        "fillOpacity": 0.01,
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)",
        "fillOpacity": 0.2
      }
    }]
  };
  var DisableIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$16(_objectSpread$16({}, props), {}, {
      id: "disable",
      ref: ref,
      icon: element$13
    }));
  });
  DisableIcon.displayName = "DisableIcon";
  var DisableIcon$1 = DisableIcon;

  function ownKeys$15(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$15(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$15(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$15(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$12 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6.3 9.7l1.4-1.4 4.3 4.29 4.3-4.3 1.4 1.42-5.7 5.7-5.7-5.7z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var DownIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$15(_objectSpread$15({}, props), {}, {
      id: "down",
      ref: ref,
      icon: element$12
    }));
  });
  DownIcon.displayName = "DownIcon";
  var DownIcon$1 = DownIcon;

  function ownKeys$14(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$14(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$14(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$14(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$11 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M11 3h2v9.59l2.3-2.3 1.4 1.42-4.7 4.7-4.7-4.7 1.4-1.42 2.3 2.3V3zM4 20v-5h2v4h12v-4h2v5c0 .5-.56 1-1 1H5c-.45 0-1-.5-1-1z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var DownloadIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$14(_objectSpread$14({}, props), {}, {
      id: "download",
      ref: ref,
      icon: element$11
    }));
  });
  DownloadIcon.displayName = "DownloadIcon";
  var DownloadIcon$1 = DownloadIcon;

  function ownKeys$13(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$13(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$13(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$13(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$10 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 7.49L13.59 6 20 12l-6.41 6L12 16.51 15.9 13H5v-2h10.9L12 7.49z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var EnterIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$13(_objectSpread$13({}, props), {}, {
      id: "enter",
      ref: ref,
      icon: element$10
    }));
  });
  EnterIcon.displayName = "EnterIcon";
  var EnterIcon$1 = EnterIcon;

  function ownKeys$12(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$12(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$12(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$12(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$$ = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2a10 10 0 100-20 10 10 0 000 20z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M10.61 12.18L7.8 15l1.42 1.41 2.82-2.81 2.81 2.81 1.36-1.36-2.81-2.82 2.82-2.82L14.79 8l-2.82 2.82L9.16 8 7.79 9.36l2.82 2.82z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var ErrorIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$12(_objectSpread$12({}, props), {}, {
      id: "error",
      ref: ref,
      icon: element$$
    }));
  });
  ErrorIcon.displayName = "ErrorIcon";
  var ErrorIcon$1 = ErrorIcon;

  function ownKeys$11(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$11(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$11(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$11(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$_ = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 12.06c0 4.97 3.61 9.1 8.33 9.94v-7.22h-2.5V12h2.5V9.78c0-2.5 1.61-3.9 3.9-3.9.71 0 1.5.12 2.21.23v2.56h-1.27c-1.23 0-1.5.6-1.5 1.39V12h2.66l-.44 2.78h-2.22V22A10.12 10.12 0 0022 12.06C22 6.52 17.5 2 12 2S2 6.53 2 12.06z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var FacebookOIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$11(_objectSpread$11({}, props), {}, {
      id: "facebook-o",
      ref: ref,
      icon: element$_
    }));
  });
  FacebookOIcon.displayName = "FacebookOIcon";
  var FacebookOIcon$1 = FacebookOIcon;

  function ownKeys$10(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$10(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$10(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$10(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$Z = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M20 3H4a1 1 0 00-1 1v16a1 1 0 001 1h8.61v-6.97h-2.34V11.3h2.34v-2c0-2.33 1.42-3.6 3.5-3.6 1 0 1.85.08 2.1.11v2.43h-1.45c-1.12 0-1.34.55-1.34 1.33v1.74h2.69l-.35 2.72h-2.34V21h4.59a1 1 0 00.99-1V4a1 1 0 00-1-1"
      }
    }]
  };
  var FacebookIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$10(_objectSpread$10({}, props), {}, {
      id: "facebook",
      ref: ref,
      icon: element$Z
    }));
  });
  FacebookIcon.displayName = "FacebookIcon";
  var FacebookIcon$1 = FacebookIcon;

  function ownKeys$$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$$(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$$(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$Y = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M10 9l5 3-5 3V9z"
      }
    }]
  };
  var FoldIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$$(_objectSpread$$({}, props), {}, {
      id: "fold",
      ref: ref,
      icon: element$Y
    }));
  });
  FoldIcon.displayName = "FoldIcon";
  var FoldIcon$1 = FoldIcon;

  function ownKeys$_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$_(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$_(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$X = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 12a10 10 0 1020 0 10 10 0 00-20 0zm18-.02a8 8 0 11-16 0 8 8 0 0116 0z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4.4 6.8a117.42 117.42 0 011.2-1.6l.02.01a3.05 3.05 0 00.37.24c.28.17.7.4 1.25.63C8.34 6.54 9.97 7 12 7a12.4 12.4 0 006-1.55 6.07 6.07 0 00.38-.24h.02L19 6l.6.8h-.01a4.52 4.52 0 01-.56.37c-.35.21-.85.48-1.5.75C16.22 8.46 14.33 9 12 9a14.39 14.39 0 01-7.03-1.83 8.1 8.1 0 01-.56-.36L4.4 6.8zM19.6 17.2l-.6.8-.6.8-.02-.01a3.47 3.47 0 00-.37-.24c-.28-.17-.7-.4-1.25-.63A12.4 12.4 0 0012 17a12.4 12.4 0 00-6 1.55 6.05 6.05 0 00-.38.24H5.6L5 18l-.6-.8h.01a3.96 3.96 0 01.56-.37c.35-.21.85-.48 1.5-.75A14.4 14.4 0 0112 15a14.4 14.4 0 017.03 1.83 8.1 8.1 0 01.56.36l.01.01z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M10.09 6.04A15.17 15.17 0 009 12c0 2.38.43 4.48 1.09 5.96.32.74.69 1.27 1.04 1.6.35.34.64.44.87.44.23 0 .52-.1.87-.43.35-.34.72-.87 1.04-1.61A15.17 15.17 0 0015 12c0-2.38-.43-4.48-1.09-5.96a5.08 5.08 0 00-1.04-1.6C12.52 4.1 12.23 4 12 4c-.23 0-.52.1-.87.43-.35.34-.72.87-1.04 1.61zm-.34-3.06C10.36 2.4 11.12 2 12 2c.88 0 1.64.4 2.25.98.6.58 1.1 1.36 1.5 2.25C16.53 7.01 17 9.41 17 12c0 2.6-.46 4.99-1.26 6.77-.4.9-.9 1.67-1.5 2.25-.6.58-1.36.98-2.24.98-.88 0-1.64-.4-2.25-.98a7.04 7.04 0 01-1.5-2.25A17.14 17.14 0 017 12c0-2.6.46-4.99 1.26-6.77.4-.9.9-1.67 1.5-2.25z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var GlobalIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$_(_objectSpread$_({}, props), {}, {
      id: "global",
      ref: ref,
      icon: element$X
    }));
  });
  GlobalIcon.displayName = "GlobalIcon";
  var GlobalIcon$1 = GlobalIcon;

  function ownKeys$Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$Z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Z(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$W = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 4h16v16H4V4z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#006EFF",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)"
      }
    }]
  };
  var HoverIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$Z(_objectSpread$Z({}, props), {}, {
      id: "hover",
      ref: ref,
      icon: element$W
    }));
  });
  HoverIcon.displayName = "HoverIcon";
  var HoverIcon$1 = HoverIcon;

  function ownKeys$Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$Y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Y(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$V = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M13 7h-2v2h2V7zm0 4h-2v6h2v-6z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var InfoIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$Y(_objectSpread$Y({}, props), {}, {
      id: "info",
      ref: ref,
      icon: element$V
    }));
  });
  InfoIcon.displayName = "InfoIcon";
  var InfoIcon$1 = InfoIcon;

  function ownKeys$X(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$X(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$X(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$X(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$U = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M20.52 12.6C17.54 16.27 14.7 18 12 18c-2.7 0-5.54-1.74-8.52-5.4a.96.96 0 010-1.2C6.46 7.73 9.3 6 12 6c2.7 0 5.54 1.74 8.52 5.4.28.35.28.85 0 1.2zM12 4C8.38 4 4.77 6.5 1.15 11.52c-.2.27-.2.69 0 .96C4.77 17.5 8.38 20 12 20c3.62 0 7.23-2.5 10.85-7.52.2-.27.2-.69 0-.96C19.23 6.5 15.62 4 12 4zm-4 8a4 4 0 108 0 4 4 0 00-8 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var InsightsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$X(_objectSpread$X({}, props), {}, {
      id: "insights",
      ref: ref,
      icon: element$U
    }));
  });
  InsightsIcon.displayName = "InsightsIcon";
  var InsightsIcon$1 = InsightsIcon;

  function ownKeys$W(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$W(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$W(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$W(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$T = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 22a10 10 0 110-20 10 10 0 010 20zm5-3.78a7.99 7.99 0 00-2.5-13.84v1.57a1 1 0 01-1 1H12v1.03a1 1 0 01-1 1H9.5v2.92h4a1 1 0 011 1v2.71H16a1 1 0 011 1v1.61zm-5 1.76v-3.14h-1.5a1 1 0 01-1-1v-2.21L4.44 9.35A7.99 7.99 0 0012 19.98z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var LanguageIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$W(_objectSpread$W({}, props), {}, {
      id: "language",
      ref: ref,
      icon: element$T
    }));
  });
  LanguageIcon.displayName = "LanguageIcon";
  var LanguageIcon$1 = LanguageIcon;

  function ownKeys$V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$V(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$V(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$S = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M14 17.7l1.41-1.4-4.29-4.3 4.3-4.3L14 6.3 8.3 12l5.7 5.7z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var LeftIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$V(_objectSpread$V({}, props), {}, {
      id: "left",
      ref: ref,
      icon: element$S
    }));
  });
  LeftIcon.displayName = "LeftIcon";
  var LeftIcon$1 = LeftIcon;

  function ownKeys$U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$U(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$U(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$R = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 2a10 10 0 100 20 10 10 0 000-20zM9.55 16.14H7.53V9.63h2.02v6.51zM8.53 8.83c-.64 0-1.06-.46-1.06-1.02 0-.57.43-1 1.08-1 .66 0 1.06.43 1.07 1 0 .57-.41 1.02-1.1 1.02zm8.42 7.31h-2.03v-3.6c0-.85-.3-1.42-1.02-1.42-.56 0-.9.39-1.04.76-.06.13-.07.32-.07.5v3.76h-2.03v-4.43c0-.82-.02-1.5-.05-2.08h1.76l.1.9h.03c.27-.42.92-1.05 2.02-1.05 1.33 0 2.33.9 2.33 2.81v3.85z"
      }
    }]
  };
  var LinkedinOIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$U(_objectSpread$U({}, props), {}, {
      id: "linkedin-o",
      ref: ref,
      icon: element$R
    }));
  });
  LinkedinOIcon.displayName = "LinkedinOIcon";
  var LinkedinOIcon$1 = LinkedinOIcon;

  function ownKeys$T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$T(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$T(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$Q = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3.72 3.02h16.52c.4 0 .72.32.72.72v16.52c0 .4-.32.71-.72.71H3.72a.72.72 0 01-.72-.71V3.74c0-.4.32-.72.72-.72zm1.94 15.3h2.67V9.75H5.66v8.57zM7 8.58a1.54 1.54 0 110-3.1 1.54 1.54 0 010 3.1zm8.64 9.74h2.66v-4.7c0-2.3-.5-4.08-3.2-4.08a2.8 2.8 0 00-2.51 1.38h-.04V9.75H10v8.57h2.66v-4.24c0-1.12.21-2.2 1.6-2.2 1.36 0 1.38 1.28 1.38 2.27v4.17z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var LinkedinIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$T(_objectSpread$T({}, props), {}, {
      id: "linkedin",
      ref: ref,
      icon: element$Q
    }));
  });
  LinkedinIcon.displayName = "LinkedinIcon";
  var LinkedinIcon$1 = LinkedinIcon;

  function ownKeys$S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$S(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$S(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$P = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12.52 21.65C14.29 20.4 20 15.91 20 10a8 8 0 10-16 0c0 5.91 5.71 10.4 7.48 11.65a.9.9 0 001.04 0zM12 13a3 3 0 100-6 3 3 0 000 6z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var LocationIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$S(_objectSpread$S({}, props), {}, {
      id: "location",
      ref: ref,
      icon: element$P
    }));
  });
  LocationIcon.displayName = "LocationIcon";
  var LocationIcon$1 = LocationIcon;

  function ownKeys$R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$R(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$R(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$O = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "rect",
      "attrs": {
        "width": 14,
        "height": 2,
        "x": 7,
        "y": 5,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 14,
        "height": 2,
        "x": 7,
        "y": 11,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 14,
        "height": 2,
        "x": 7,
        "y": 17,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 3,
        "y": 5,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 3,
        "y": 11,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 2,
        "height": 2,
        "x": 3,
        "y": 17,
        "fill": "currentColor",
        "rx": 1
      }
    }]
  };
  var MenuSubIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$R(_objectSpread$R({}, props), {}, {
      id: "menu-sub",
      ref: ref,
      icon: element$O
    }));
  });
  MenuSubIcon.displayName = "MenuSubIcon";
  var MenuSubIcon$1 = MenuSubIcon;

  function ownKeys$Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$Q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$N = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "rect",
      "attrs": {
        "width": 18,
        "height": 2,
        "x": 3,
        "y": 5,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 18,
        "height": 2,
        "x": 3,
        "y": 11,
        "fill": "currentColor",
        "rx": 1
      }
    }, {
      "tag": "rect",
      "attrs": {
        "width": 18,
        "height": 2,
        "x": 3,
        "y": 17,
        "fill": "currentColor",
        "rx": 1
      }
    }]
  };
  var MenuIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$Q(_objectSpread$Q({}, props), {}, {
      id: "menu",
      ref: ref,
      icon: element$N
    }));
  });
  MenuIcon.displayName = "MenuIcon";
  var MenuIcon$1 = MenuIcon;

  function ownKeys$P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$P(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$P(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$M = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M17.8 13.06c.22.21.27.45.15.73-.12.28-.32.42-.62.42h-3.98l2.1 5.05c.07.18.07.35 0 .52a.68.68 0 01-.36.37l-1.84.8a.64.64 0 01-.51 0 .68.68 0 01-.37-.36l-1.98-4.8-3.25 3.31a.64.64 0 01-.72.15.63.63 0 01-.42-.63V2.69c0-.3.14-.5.42-.63a.64.64 0 01.72.15L17.8 13.06z"
      }
    }]
  };
  var MouseIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$P(_objectSpread$P({}, props), {}, {
      id: "mouse",
      ref: ref,
      icon: element$M
    }));
  });
  MouseIcon.displayName = "MouseIcon";
  var MouseIcon$1 = MouseIcon;

  function ownKeys$O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$O(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$O(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$L = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 4h16v16H4V4z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)",
        "fillOpacity": 0.2
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#006EFF",
        "d": "M8 11h8v2H8z"
      }
    }]
  };
  var NotAllSelectedIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$O(_objectSpread$O({}, props), {}, {
      id: "not_all_selected",
      ref: ref,
      icon: element$L
    }));
  });
  NotAllSelectedIcon.displayName = "NotAllSelectedIcon";
  var NotAllSelectedIcon$1 = NotAllSelectedIcon;

  function ownKeys$N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$N(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$N(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$K = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 22a2 2 0 01-2-2h4a2 2 0 01-2 2zm8-3H4v-2l2-1v-5.5c0-3.46 1.42-5.7 4-6.32V2h4v2.18c2.58.61 4 2.86 4 6.32V16l2 1v2zM12 5.75A3.6 3.6 0 008.87 7.2 5.7 5.7 0 008 10.5V17h8v-6.5a5.7 5.7 0 00-.88-3.3A3.6 3.6 0 0012 5.75z"
      }
    }]
  };
  var NotifyIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$N(_objectSpread$N({}, props), {}, {
      id: "notify",
      ref: ref,
      icon: element$K
    }));
  });
  NotifyIcon.displayName = "NotifyIcon";
  var NotifyIcon$1 = NotifyIcon;

  function ownKeys$M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$M(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$M(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$J = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M15.1 9.64c0 .5-.13.94-.4 1.33-.26.39-.61.7-1.06.91.52.22.93.55 1.23.98.3.43.46.91.46 1.45 0 .86-.3 1.55-.87 2.06-.58.51-1.35.77-2.3.77-.95 0-1.72-.26-2.3-.77A2.63 2.63 0 019 14.31c0-.53.15-1.02.44-1.45.3-.44.7-.76 1.22-.99a2.6 2.6 0 01-1.04-.9 2.34 2.34 0 01-.39-1.33c0-.83.27-1.5.8-2 .55-.48 1.26-.73 2.13-.73.88 0 1.59.25 2.12.74.55.5.82 1.16.82 2zm-1.03 4.65c0-.56-.18-1.01-.54-1.36a1.87 1.87 0 00-1.38-.53c-.57 0-1.03.17-1.37.52-.34.35-.52.8-.52 1.37 0 .56.17 1 .5 1.33.34.32.8.48 1.4.48.6 0 1.06-.16 1.4-.48.34-.33.5-.77.5-1.33zm-1.9-6.34c-.5 0-.9.15-1.21.46-.31.3-.46.73-.46 1.26 0 .5.15.91.45 1.23.3.3.7.46 1.21.46s.91-.15 1.21-.46c.31-.32.46-.73.46-1.23 0-.51-.15-.92-.47-1.24a1.6 1.6 0 00-1.2-.48z"
      }
    }]
  };
  var NumEightIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$M(_objectSpread$M({}, props), {}, {
      id: "num-eight",
      ref: ref,
      icon: element$J
    }));
  });
  NumEightIcon.displayName = "NumEightIcon";
  var NumEightIcon$1 = NumEightIcon;

  function ownKeys$L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$L(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$L(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$I = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M9.36 12.01l.5-4.96h5.1v1.17h-4.03l-.3 2.71a3.21 3.21 0 011.66-.43c.91 0 1.63.3 2.17.9.53.6.8 1.4.8 2.43a3.4 3.4 0 01-.84 2.42c-.55.6-1.32.89-2.32.89-.88 0-1.6-.25-2.15-.73A2.92 2.92 0 019 14.38h1.2c.07.57.28 1 .6 1.3.33.28.77.42 1.3.42.6 0 1.05-.2 1.38-.6.34-.4.51-.95.51-1.66 0-.66-.18-1.2-.55-1.6-.36-.4-.84-.6-1.44-.6-.55 0-.98.11-1.3.36l-.33.27-1.01-.26z"
      }
    }]
  };
  var NumFiveIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$L(_objectSpread$L({}, props), {}, {
      id: "num-five",
      ref: ref,
      icon: element$I
    }));
  });
  NumFiveIcon.displayName = "NumFiveIcon";
  var NumFiveIcon$1 = NumFiveIcon;

  function ownKeys$K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$K(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$K(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$H = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M13.8 13.61h1.38v1.03H13.8v2.31h-1.27v-2.3H8v-.75L12.46 7h1.34v6.61zm-4.36 0h3.1V8.73l-.16.27-2.94 4.61z"
      }
    }]
  };
  var NumFourIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$K(_objectSpread$K({}, props), {}, {
      id: "num-four",
      ref: ref,
      icon: element$H
    }));
  });
  NumFourIcon.displayName = "NumFourIcon";
  var NumFourIcon$1 = NumFourIcon;

  function ownKeys$J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$J(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$J(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$G = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M13.99 12.63c-.26.3-.58.56-.95.75-.36.2-.77.3-1.2.3-.58 0-1.08-.15-1.5-.43a2.77 2.77 0 01-1-1.2 4.09 4.09 0 01-.34-1.7c0-.66.13-1.26.38-1.8a2.8 2.8 0 012.7-1.64c.99 0 1.76.37 2.33 1.1.57.74.85 1.74.85 3.02v.36c0 1.94-.38 3.36-1.15 4.25-.76.89-1.92 1.34-3.46 1.37h-.25v-1.07h.27a3.49 3.49 0 002.4-.81c.56-.53.87-1.37.92-2.5zm-1.95 0c.43 0 .82-.13 1.17-.4.36-.25.62-.58.79-.96v-.5c0-.83-.18-1.5-.54-2.03-.36-.52-.82-.78-1.37-.78-.56 0-1 .22-1.34.65-.34.42-.5.98-.5 1.68 0 .68.16 1.24.48 1.68.33.44.77.65 1.31.65z"
      }
    }]
  };
  var NumNineIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$J(_objectSpread$J({}, props), {}, {
      id: "num-nine",
      ref: ref,
      icon: element$G
    }));
  });
  NumNineIcon.displayName = "NumNineIcon";
  var NumNineIcon$1 = NumNineIcon;

  function ownKeys$I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$I(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$I(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$F = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M12.98 17h-1.27V8.57l-2.55.94V8.36L12.8 7h.2v10z"
      }
    }]
  };
  var NumOneIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$I(_objectSpread$I({}, props), {}, {
      id: "num-one",
      ref: ref,
      icon: element$F
    }));
  });
  NumOneIcon.displayName = "NumOneIcon";
  var NumOneIcon$1 = NumOneIcon;

  function ownKeys$H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$H(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$H(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$E = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M15.73 7.76L11.6 17h-1.32l4.1-8.91H9V7.05h6.73v.7z"
      }
    }]
  };
  var NumSevenIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$H(_objectSpread$H({}, props), {}, {
      id: "num-seven",
      ref: ref,
      icon: element$E
    }));
  });
  NumSevenIcon.displayName = "NumSevenIcon";
  var NumSevenIcon$1 = NumSevenIcon;

  function ownKeys$G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$G(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$G(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$D = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M13.89 7.04v1.07h-.23c-.99.02-1.77.31-2.36.88a3.64 3.64 0 00-1 2.38 2.7 2.7 0 012.14-.9c.86 0 1.55.3 2.07.92.52.6.78 1.4.78 2.36 0 1.03-.28 1.85-.84 2.46-.56.62-1.3.93-2.24.93-.96 0-1.73-.37-2.32-1.1A4.36 4.36 0 019 13.21v-.48c0-1.83.39-3.23 1.17-4.2.78-.97 1.95-1.47 3.5-1.49h.22zm-1.66 4.48c-.44 0-.84.13-1.2.4-.36.25-.62.58-.76.97v.47c0 .82.19 1.48.56 1.98.36.5.82.75 1.38.75a1.6 1.6 0 001.34-.63c.32-.42.49-.97.49-1.65 0-.68-.17-1.23-.5-1.65a1.58 1.58 0 00-1.31-.64z"
      }
    }]
  };
  var NumSixIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$G(_objectSpread$G({}, props), {}, {
      id: "num-six",
      ref: ref,
      icon: element$D
    }));
  });
  NumSixIcon.displayName = "NumSixIcon";
  var NumSixIcon$1 = NumSixIcon;

  function ownKeys$F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$F(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$F(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$C = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M15.35 17H8.83v-.9l3.44-3.84a8.1 8.1 0 001.06-1.4c.2-.37.29-.75.29-1.13 0-.52-.16-.95-.47-1.28-.32-.33-.74-.5-1.26-.5-.63 0-1.12.18-1.47.54-.35.35-.52.85-.52 1.49H8.64c0-.92.3-1.66.88-2.22a3.3 3.3 0 012.37-.85c.93 0 1.66.24 2.2.73.53.48.8 1.13.8 1.94 0 .98-.62 2.14-1.87 3.5l-2.67 2.89h5V17z"
      }
    }]
  };
  var NumTwoIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$F(_objectSpread$F({}, props), {}, {
      id: "num-two",
      ref: ref,
      icon: element$C
    }));
  });
  NumTwoIcon.displayName = "NumTwoIcon";
  var NumTwoIcon$1 = NumTwoIcon;

  function ownKeys$E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$E(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$E(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$B = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M15.28 12.75c0 1.49-.25 2.59-.76 3.3-.5.73-1.3 1.09-2.37 1.09-1.06 0-1.85-.35-2.36-1.06A5.5 5.5 0 019 12.93v-1.7c0-1.46.25-2.54.76-3.25.5-.71 1.3-1.07 2.38-1.07 1.07 0 1.86.34 2.36 1.03.5.69.77 1.74.78 3.17v1.64zm-1.26-1.72c0-1.08-.15-1.85-.45-2.34-.3-.5-.78-.74-1.43-.74-.65 0-1.12.24-1.42.73-.3.49-.45 1.24-.46 2.25v2.02c0 1.08.16 1.87.47 2.39.31.5.79.76 1.42.76.63 0 1.09-.24 1.39-.72.3-.48.46-1.24.48-2.28v-2.07z"
      }
    }]
  };
  var NumZeroIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$E(_objectSpread$E({}, props), {}, {
      id: "num-zero",
      ref: ref,
      icon: element$B
    }));
  });
  NumZeroIcon.displayName = "NumZeroIcon";
  var NumZeroIcon$1 = NumZeroIcon;

  function ownKeys$D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$D(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$D(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$A = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6 4.86a.5.5 0 01.75-.43l12.49 7.14a.5.5 0 010 .86l-12.5 7.14a.5.5 0 01-.74-.43V4.86z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var PlayerIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$D(_objectSpread$D({}, props), {}, {
      id: "player",
      ref: ref,
      icon: element$A
    }));
  });
  PlayerIcon.displayName = "PlayerIcon";
  var PlayerIcon$1 = PlayerIcon;

  function ownKeys$C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$C(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$C(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$z = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M16 3a1 1 0 011 1v2.38h3a1 1 0 011 1V20a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h12zm-1 2H5v14h10V5zm2 3.5V19h2V8.5h-2zM13 14H7v2h6v-2zM7 8h6v4H7V8z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var PressCenterIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$C(_objectSpread$C({}, props), {}, {
      id: "press_center",
      ref: ref,
      icon: element$z
    }));
  });
  PressCenterIcon.displayName = "PressCenterIcon";
  var PressCenterIcon$1 = PressCenterIcon;

  function ownKeys$B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$B(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$B(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$y = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 4a1 1 0 000 2v12a1 1 0 001 1h6l-1.39 1.39a.5.5 0 00.35.85H15.04a.5.5 0 00.35-.85L14 19h6a1 1 0 001-1V6a1 1 0 100-2H3zm16 2H5v11h14V6zM6.28 13.58l1.44 1.39 3.12-3.24 3.38 2.56 3.58-3.9-1.47-1.35-2.35 2.55-3.34-2.53-4.36 4.52z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var ProductUpdatesIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$B(_objectSpread$B({}, props), {}, {
      id: "product_updates",
      ref: ref,
      icon: element$y
    }));
  });
  ProductUpdatesIcon.displayName = "ProductUpdatesIcon";
  var ProductUpdatesIcon$1 = ProductUpdatesIcon;

  function ownKeys$A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$A(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$A(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$x = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 12a8 8 0 1116 0 8 8 0 01-16 0z",
        "fillOpacity": 0.01
      }
    }, {
      "tag": "path",
      "attrs": {
        "stroke": "currentColor",
        "d": "M4.5 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
        "strokeOpacity": 0.2
      }
    }]
  };
  var RadioDisableIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$A(_objectSpread$A({}, props), {}, {
      id: "radio-disable",
      ref: ref,
      icon: element$x
    }));
  });
  RadioDisableIcon.displayName = "RadioDisableIcon";
  var RadioDisableIcon$1 = RadioDisableIcon;

  function ownKeys$z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$z(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$w = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "stroke": "#006EFF",
        "d": "M4.5 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z"
      }
    }]
  };
  var RadioHoverIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$z(_objectSpread$z({}, props), {}, {
      id: "radio-hover",
      ref: ref,
      icon: element$w
    }));
  });
  RadioHoverIcon.displayName = "RadioHoverIcon";
  var RadioHoverIcon$1 = RadioHoverIcon;

  function ownKeys$y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$y(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$v = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 12a8 8 0 1116 0 8 8 0 01-16 0z",
        "fillOpacity": 0.01
      }
    }, {
      "tag": "path",
      "attrs": {
        "stroke": "currentColor",
        "d": "M4.5 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
        "strokeOpacity": 0.2
      }
    }, {
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 4,
        "fill": "#DBEBFF"
      }
    }]
  };
  var RadioSelectedDisableIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$y(_objectSpread$y({}, props), {}, {
      id: "radio-selected-disable",
      ref: ref,
      icon: element$v
    }));
  });
  RadioSelectedDisableIcon.displayName = "RadioSelectedDisableIcon";
  var RadioSelectedDisableIcon$1 = RadioSelectedDisableIcon;

  function ownKeys$x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$x(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$x(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$u = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 12a8 8 0 1116 0 8 8 0 01-16 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "stroke": "currentColor",
        "d": "M4.5 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
        "strokeOpacity": 0.2
      }
    }, {
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 4,
        "fill": "#006EFF"
      }
    }]
  };
  var RadioSelectedIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$x(_objectSpread$x({}, props), {}, {
      id: "radio-selected",
      ref: ref,
      icon: element$u
    }));
  });
  RadioSelectedIcon.displayName = "RadioSelectedIcon";
  var RadioSelectedIcon$1 = RadioSelectedIcon;

  function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$w(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$t = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 12a8 8 0 1116 0 8 8 0 01-16 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "stroke": "currentColor",
        "d": "M4.5 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
        "strokeOpacity": 0.2
      }
    }]
  };
  var RadioUnselectedIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$w(_objectSpread$w({}, props), {}, {
      id: "radio-unselected",
      ref: ref,
      icon: element$t
    }));
  });
  RadioUnselectedIcon.displayName = "RadioUnselectedIcon";
  var RadioUnselectedIcon$1 = RadioUnselectedIcon;

  function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$v(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$s = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M10 6.3L8.59 7.7l4.29 4.3-4.3 4.3L10 17.7l5.7-5.7L10 6.3z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var RightIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$v(_objectSpread$v({}, props), {}, {
      id: "right",
      ref: ref,
      icon: element$s
    }));
  });
  RightIcon.displayName = "RightIcon";
  var RightIcon$1 = RightIcon;

  function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$u(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$r = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M17 11a6 6 0 11-12 0 6 6 0 0112 0zm-1.1 6.32a8 8 0 111.41-1.41l3.47 3.45a1 1 0 01-1.42 1.42l-3.45-3.46z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var SearchIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$u(_objectSpread$u({}, props), {}, {
      id: "search",
      ref: ref,
      icon: element$r
    }));
  });
  SearchIcon.displayName = "SearchIcon";
  var SearchIcon$1 = SearchIcon;

  function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$t(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$q = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4h16v16H4V4z",
        "fillOpacity": 0.01,
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)",
        "fillOpacity": 0.2
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#DBEBFF",
        "d": "M6.81 12.04l-.81.85L9.84 17 18 8.88 17.15 8l-7.36 6.38-2.98-2.34z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var SelectedDisableIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$t(_objectSpread$t({}, props), {}, {
      id: "selected-disable",
      ref: ref,
      icon: element$q
    }));
  });
  SelectedDisableIcon.displayName = "SelectedDisableIcon";
  var SelectedDisableIcon$1 = SelectedDisableIcon;

  function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$p = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 4h16v16H4V4z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)",
        "fillOpacity": 0.2
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#006EFF",
        "d": "M6.81 12.04l-.81.85L9.84 17 18 8.88 17.15 8l-7.36 6.38-2.98-2.34z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var SelectedIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$s(_objectSpread$s({}, props), {}, {
      id: "selected",
      ref: ref,
      icon: element$p
    }));
  });
  SelectedIcon.displayName = "SelectedIcon";
  var SelectedIcon$1 = SelectedIcon;

  function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$o = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4.07 11.41l-1.29 1.35 6.13 6.5 13-12.85-1.37-1.4-11.72 10.1-4.75-3.7z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var SuccessIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$r(_objectSpread$r({}, props), {}, {
      id: "success",
      ref: ref,
      icon: element$o
    }));
  });
  SuccessIcon.displayName = "SuccessIcon";
  var SuccessIcon$1 = SuccessIcon;

  function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$n = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2a10 10 0 100-20 10 10 0 000 20z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M8 11.5l-1.15 1 4.09 4.35L20 8l-1-1-8 6.5-3-2z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var SuccessOIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$q(_objectSpread$q({}, props), {}, {
      id: "success_o",
      ref: ref,
      icon: element$n
    }));
  });
  SuccessOIcon.displayName = "SuccessOIcon";
  var SuccessOIcon$1 = SuccessOIcon;

  function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$m = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "circle",
      "attrs": {
        "cx": 12,
        "cy": 12,
        "r": 10,
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M11.02 11.5h.95c.6-.01 1.07-.17 1.41-.47.34-.3.51-.72.51-1.24 0-1.17-.58-1.75-1.74-1.75-.55 0-.98.16-1.31.47-.32.31-.49.72-.49 1.24H9.1c0-.79.29-1.44.86-1.96a3.15 3.15 0 012.2-.79c.94 0 1.68.25 2.2.75.54.5.8 1.18.8 2.07 0 .43-.13.85-.41 1.25-.28.41-.66.71-1.15.91.55.18.97.46 1.27.86.3.4.45.9.45 1.47 0 .9-.3 1.6-.88 2.13-.58.52-1.34.79-2.27.79-.94 0-1.7-.26-2.29-.76a2.52 2.52 0 01-.87-2h1.27c0 .52.17.94.51 1.25.35.32.8.47 1.38.47.6 0 1.08-.16 1.4-.47.32-.32.48-.78.48-1.38 0-.58-.17-1.02-.53-1.33a2.32 2.32 0 00-1.54-.48h-.95V11.5z"
      }
    }]
  };
  var ThreeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$p(_objectSpread$p({}, props), {}, {
      id: "three",
      ref: ref,
      icon: element$m
    }));
  });
  ThreeIcon.displayName = "ThreeIcon";
  var ThreeIcon$1 = ThreeIcon;

  function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$l = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 2a10 10 0 100 20 10 10 0 000-20zm4.8 7.54l.01.32a7 7 0 01-7.05 7.05c-1.41 0-2.71-.4-3.81-1.11l.6.03c1.16 0 2.22-.4 3.08-1.06-1.1-.02-2-.73-2.32-1.72.38.06.72.06 1.12-.04a2.48 2.48 0 01-1.99-2.43v-.04c.33.19.72.3 1.12.32a2.48 2.48 0 01-.77-3.31 7.04 7.04 0 005.11 2.59 2.48 2.48 0 014.24-2.27 4.9 4.9 0 001.57-.6 2.47 2.47 0 01-1.09 1.37c.5-.06.98-.2 1.43-.39-.34.5-.76.94-1.24 1.29z"
      }
    }]
  };
  var TwitterOIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$o(_objectSpread$o({}, props), {}, {
      id: "twitter-o",
      ref: ref,
      icon: element$l
    }));
  });
  TwitterOIcon.displayName = "TwitterOIcon";
  var TwitterOIcon$1 = TwitterOIcon;

  function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$k = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M20.9 5.79a7.8 7.8 0 01-1.84 1.95l.01.5a11.04 11.04 0 01-1.74 5.94c-.58.93-1.28 1.75-2.1 2.46a9.26 9.26 0 01-2.92 1.71A10.42 10.42 0 013 17.3a7.04 7.04 0 005.44-1.57 3.7 3.7 0 01-3.43-2.62 3.68 3.68 0 001.66-.07 3.72 3.72 0 01-2.94-3.71v-.04c.52.3 1.07.45 1.66.48A3.8 3.8 0 013.77 6.6c0-.69.16-1.33.5-1.91a10.45 10.45 0 007.55 3.96c-.06-.3-.09-.59-.09-.87a3.7 3.7 0 011.07-2.68 3.48 3.48 0 012.6-1.1c1.06 0 1.95.4 2.68 1.2.82-.17 1.6-.47 2.32-.92-.28.9-.81 1.6-1.6 2.09a7.1 7.1 0 002.1-.6z"
      }
    }]
  };
  var TwitterIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$n(_objectSpread$n({}, props), {}, {
      id: "twitter",
      ref: ref,
      icon: element$k
    }));
  });
  TwitterIcon.displayName = "TwitterIcon";
  var TwitterIcon$1 = TwitterIcon;

  function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$j = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15.5 9.5l-3 5-3-5h6z"
      }
    }]
  };
  var UnfoldIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$m(_objectSpread$m({}, props), {}, {
      id: "unfold",
      ref: ref,
      icon: element$j
    }));
  });
  UnfoldIcon.displayName = "UnfoldIcon";
  var UnfoldIcon$1 = UnfoldIcon;

  function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$i = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "mask",
      "attrs": {
        "id": "a",
        "fill": "#fff"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "d": "M4 4h16v16H4V4z",
          "fillRule": "evenodd",
          "clipRule": "evenodd"
        }
      }]
    }, {
      "tag": "path",
      "attrs": {
        "fill": "#fff",
        "d": "M4 4h16v16H4V4z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 16v1h1v-1h-1zM4 20H3v1h1v-1zM4 5h16V3H4v2zm15-1v16h2V4h-2zm1 15H4v2h16v-2zM5 20V4H3v16h2z",
        "mask": "url(#a)",
        "fillOpacity": 0.2
      }
    }]
  };
  var UnselectedIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$l(_objectSpread$l({}, props), {}, {
      id: "unselected",
      ref: ref,
      icon: element$i
    }));
  });
  UnselectedIcon.displayName = "UnselectedIcon";
  var UnselectedIcon$1 = UnselectedIcon;

  function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$h = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6.3 14l1.4 1.41 4.3-4.29 4.3 4.3L17.7 14 12 8.3 6.3 14z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var UpIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$k(_objectSpread$k({}, props), {}, {
      id: "up",
      ref: ref,
      icon: element$h
    }));
  });
  UpIcon.displayName = "UpIcon";
  var UpIcon$1 = UpIcon;

  function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$g = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M21.53 20H3a1 1 0 01-.87-1.5l9.27-16a1 1 0 011.73 0l9.27 16a1 1 0 01-.87 1.5zM12.27 5L4.74 18H19.8L12.27 5zm1 9h-2V9h2v5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M11.27 15h2v2h-2v-2z"
      }
    }]
  };
  var WarningIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$j(_objectSpread$j({}, props), {}, {
      id: "warning",
      ref: ref,
      icon: element$g
    }));
  });
  WarningIcon.displayName = "WarningIcon";
  var WarningIcon$1 = WarningIcon;

  function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$f = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 18V6h16v12H4zM2 5a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5zm7 3.86v6.28c0 .38.41.62.75.43l5.49-3.14a.5.5 0 000-.86l-5.5-3.14a.5.5 0 00-.74.43z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var WebinarIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$i(_objectSpread$i({}, props), {}, {
      id: "webinar",
      ref: ref,
      icon: element$f
    }));
  });
  WebinarIcon.displayName = "WebinarIcon";
  var WebinarIcon$1 = WebinarIcon;

  function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$e = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M16.16 8.44c.25 0 .5.02.72.05-.65-3.14-3.83-5.47-7.48-5.47C5.32 3.02 2 5.94 2 9.65c0 2.13 1.1 3.9 2.95 5.27l-.74 2.34 2.6-1.34.36.07c.76.17 1.44.32 2.23.32.23 0 .47 0 .69-.03a6.2 6.2 0 016.06-7.82l.01-.02zm-3.98-2.1c.56 0 .94.39.94.98 0 .57-.38.98-.94.98-.55 0-1.11-.41-1.11-.98 0-.6.56-.98 1.11-.98zm-6.3.98c0 .57.56.98 1.11.98.56 0 .94-.41.94-.98 0-.6-.38-.98-.94-.98-.55 0-1.11.39-1.11.98z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }, {
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M22.94 14.53c0-3.11-2.98-5.66-6.3-5.66-3.52 0-6.3 2.53-6.3 5.66 0 3.12 2.78 5.65 6.3 5.65.72 0 1.44-.19 2.18-.38l.04-.01 2.03 1.18-.55-1.96c1.47-1.15 2.58-2.72 2.58-4.48h.02zm-8.35-.99c-.36 0-.74-.37-.74-.76 0-.4.38-.79.74-.79.56 0 .93.4.93.79s-.37.78-.93.78v-.02zm3.34-.76c0 .39.38.76.75.76l-.01.02c.55 0 .93-.4.93-.78 0-.4-.38-.79-.93-.79-.36 0-.74.4-.74.79z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var WechatIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$h(_objectSpread$h({}, props), {}, {
      id: "wechat",
      ref: ref,
      icon: element$e
    }));
  });
  WechatIcon.displayName = "WechatIcon";
  var WechatIcon$1 = WechatIcon;

  function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$d = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6 19v1h12v-1H6zm0-2h12V4h-7v6L9.5 9 8 10V4H6v13zM5 2a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1H5z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  };
  var WhitepaperIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase$1, _objectSpread$g(_objectSpread$g({}, props), {}, {
      id: "whitepaper",
      ref: ref,
      icon: element$d
    }));
  });
  WhitepaperIcon.displayName = "WhitepaperIcon";
  var WhitepaperIcon$1 = WhitepaperIcon;

  var manifest = [{
    stem: "analyst_report",
    icon: "AnalystReport"
  }, {
    stem: "avatar",
    icon: "Avatar"
  }, {
    stem: "calculator",
    icon: "Calculator"
  }, {
    stem: "click",
    icon: "Click"
  }, {
    stem: "close",
    icon: "Close"
  }, {
    stem: "contact_sales",
    icon: "ContactSales"
  }, {
    stem: "contact_us",
    icon: "ContactUs"
  }, {
    stem: "disable",
    icon: "Disable"
  }, {
    stem: "down",
    icon: "Down"
  }, {
    stem: "download",
    icon: "Download"
  }, {
    stem: "enter",
    icon: "Enter"
  }, {
    stem: "error",
    icon: "Error"
  }, {
    stem: "facebook-o",
    icon: "FacebookO"
  }, {
    stem: "facebook",
    icon: "Facebook"
  }, {
    stem: "fold",
    icon: "Fold"
  }, {
    stem: "global",
    icon: "Global"
  }, {
    stem: "hover",
    icon: "Hover"
  }, {
    stem: "info",
    icon: "Info"
  }, {
    stem: "insights",
    icon: "Insights"
  }, {
    stem: "language",
    icon: "Language"
  }, {
    stem: "left",
    icon: "Left"
  }, {
    stem: "linkedin-o",
    icon: "LinkedinO"
  }, {
    stem: "linkedin",
    icon: "Linkedin"
  }, {
    stem: "location",
    icon: "Location"
  }, {
    stem: "menu-sub",
    icon: "MenuSub"
  }, {
    stem: "menu",
    icon: "Menu"
  }, {
    stem: "mouse",
    icon: "Mouse"
  }, {
    stem: "not_all_selected",
    icon: "NotAllSelected"
  }, {
    stem: "notify",
    icon: "Notify"
  }, {
    stem: "num-eight",
    icon: "NumEight"
  }, {
    stem: "num-five",
    icon: "NumFive"
  }, {
    stem: "num-four",
    icon: "NumFour"
  }, {
    stem: "num-nine",
    icon: "NumNine"
  }, {
    stem: "num-one",
    icon: "NumOne"
  }, {
    stem: "num-seven",
    icon: "NumSeven"
  }, {
    stem: "num-six",
    icon: "NumSix"
  }, {
    stem: "num-two",
    icon: "NumTwo"
  }, {
    stem: "num-zero",
    icon: "NumZero"
  }, {
    stem: "player",
    icon: "Player"
  }, {
    stem: "press_center",
    icon: "PressCenter"
  }, {
    stem: "product_updates",
    icon: "ProductUpdates"
  }, {
    stem: "radio-disable",
    icon: "RadioDisable"
  }, {
    stem: "radio-hover",
    icon: "RadioHover"
  }, {
    stem: "radio-selected-disable",
    icon: "RadioSelectedDisable"
  }, {
    stem: "radio-selected",
    icon: "RadioSelected"
  }, {
    stem: "radio-unselected",
    icon: "RadioUnselected"
  }, {
    stem: "right",
    icon: "Right"
  }, {
    stem: "search",
    icon: "Search"
  }, {
    stem: "selected-disable",
    icon: "SelectedDisable"
  }, {
    stem: "selected",
    icon: "Selected"
  }, {
    stem: "success",
    icon: "Success"
  }, {
    stem: "success_o",
    icon: "SuccessO"
  }, {
    stem: "three",
    icon: "Three"
  }, {
    stem: "twitter-o",
    icon: "TwitterO"
  }, {
    stem: "twitter",
    icon: "Twitter"
  }, {
    stem: "unfold",
    icon: "Unfold"
  }, {
    stem: "unselected",
    icon: "Unselected"
  }, {
    stem: "up",
    icon: "Up"
  }, {
    stem: "warning",
    icon: "Warning"
  }, {
    stem: "webinar",
    icon: "Webinar"
  }, {
    stem: "wechat",
    icon: "Wechat"
  }, {
    stem: "whitepaper",
    icon: "Whitepaper"
  }];

  function checkScriptAndLoad(url, className) {
    if (!document || !url || typeof url !== "string") return;

    if (document.querySelectorAll(".".concat(className, "[src=\"").concat(url, "\"]")).length > 0) {
      return;
    }

    var svg = document.createElement("script");
    svg.setAttribute("class", className);
    svg.setAttribute("src", url);
    document.body.appendChild(svg);
  }

  function checkLinkAndLoad(url, className) {
    if (!document || !url || typeof url !== "string") return;

    if (document.querySelectorAll(".".concat(className, "[href=\"").concat(url, "\"]")).length > 0) {
      return;
    }

    var link = document.createElement("link");
    link.setAttribute("class", className);
    link.setAttribute("href", url);
    link.setAttribute("rel", "stylesheet");
    document.head.appendChild(link);
  }

  var _excluded$2 = ["name", "size", "tag", "className", "url", "loadDefaultIcons", "style"];

  function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var CDN_ICONFONT_URL = "https://ixd-icons.pages.woa.com/public/index.css";
  var IconFont = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var _useConfig = useConfig(),
        classPrefix = _useConfig.classPrefix;

    var name = props.name,
        size = props.size,
        _props$tag = props.tag,
        tag = _props$tag === void 0 ? "i" : _props$tag,
        customClassName = props.className,
        _props$url = props.url,
        url = _props$url === void 0 ? [] : _props$url,
        _props$loadDefaultIco = props.loadDefaultIcons,
        loadDefaultIcons = _props$loadDefaultIco === void 0 ? true : _props$loadDefaultIco,
        customStyle = props.style,
        htmlProps = _objectWithoutProperties(props, _excluded$2);

    var _useSizeProps = useSizeProps(size),
        sizeClassName = _useSizeProps.className,
        sizeStyle = _useSizeProps.style;

    var className = React.useMemo(function () {
      return classNames("".concat(classPrefix, "-icon"), "".concat(classPrefix, "-icon-").concat(name), sizeClassName, customClassName);
    }, [classPrefix, customClassName, name, sizeClassName]);
    React.useEffect(function () {
      if (typeof document === "undefined") {
        return;
      }

      if (!loadDefaultIcons) {
        return;
      }

      checkLinkAndLoad(CDN_ICONFONT_URL, "".concat(classPrefix, "-iconfont-stylesheet--unique-class"));
    }, [classPrefix, loadDefaultIcons]);
    React.useEffect(function () {
      var urls = Array.isArray(url) ? url : [url];
      urls.forEach(function (url2) {
        checkLinkAndLoad(url2, "".concat(classPrefix, "-iconfont-stylesheet--unique-class"));
      });
    }, [classPrefix, url]);
    return /*#__PURE__*/React.createElement(tag, _objectSpread$f({
      ref: ref,
      style: _objectSpread$f(_objectSpread$f({}, customStyle), sizeStyle),
      className: className
    }, htmlProps));
  });
  IconFont.displayName = "Icon";

  var _excluded$1 = ["name", "size", "url", "loadDefaultIcons", "className", "style"];

  function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var CDN_SVGSPRITE_URL = "https://tdesign.gtimg.com/icon/0.0.3/fonts/index.js";
  var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var _useConfig = useConfig(),
        classPrefix = _useConfig.classPrefix;

    var name = props.name,
        size = props.size,
        _props$url = props.url,
        url = _props$url === void 0 ? [] : _props$url,
        _props$loadDefaultIco = props.loadDefaultIcons,
        loadDefaultIcons = _props$loadDefaultIco === void 0 ? true : _props$loadDefaultIco,
        customClassName = props.className,
        customStyle = props.style,
        restProps = _objectWithoutProperties(props, _excluded$1);

    var _useSizeProps = useSizeProps(size),
        sizeClassName = _useSizeProps.className,
        sizeStyle = _useSizeProps.style;

    var className = React.useMemo(function () {
      return classNames("".concat(classPrefix, "-icon"), "".concat(classPrefix, "-icon-").concat(name), sizeClassName, customClassName);
    }, [classPrefix, customClassName, name, sizeClassName]);
    React.useEffect(function () {
      if (typeof document === "undefined") {
        return;
      }

      if (!loadDefaultIcons) {
        return;
      }

      checkScriptAndLoad(CDN_SVGSPRITE_URL, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
    }, [classPrefix, loadDefaultIcons]);
    React.useEffect(function () {
      var urls = Array.isArray(url) ? url : [url];
      urls.forEach(function (url2) {
        checkScriptAndLoad(url2, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
      });
    }, [classPrefix, url]);
    return /* @__PURE__ */React__namespace.createElement("svg", _objectSpread$e({
      ref: ref,
      className: className,
      style: _objectSpread$e(_objectSpread$e({}, customStyle), sizeStyle)
    }, restProps), /* @__PURE__ */React__namespace.createElement("use", {
      xlinkHref: "#t-icon-".concat(name)
    }));
  });
  Icon.displayName = "Icon";

  var _excluded = ["icon", "id", "className", "size", "style"];

  function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function render(node, id, rootProps) {
    return /*#__PURE__*/React.createElement(node.tag, _objectSpread$d(_objectSpread$d({
      key: id
    }, node.attrs), rootProps), (node.children || []).map(function (child, index) {
      return render(child, "".concat(id, "-").concat(node.tag, "-").concat(index));
    }));
  }

  var IconBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var icon = props.icon,
        id = props.id,
        className = props.className,
        size = props.size,
        style = props.style,
        restProps = _objectWithoutProperties(props, _excluded);

    var _useSizeProps = useSizeProps(size),
        sizeClassName = _useSizeProps.className,
        sizeStyle = _useSizeProps.style;

    var cls = classNames("t-icon", "t-icon-".concat(id), className, sizeClassName);
    return render(icon, "".concat(id), _objectSpread$d({
      ref: ref,
      className: cls,
      style: _objectSpread$d(_objectSpread$d({}, style), sizeStyle)
    }, restProps));
  });
  IconBase.displayName = "TIconBase";

  function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$c = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/ai.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var AiIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$c(_objectSpread$c({}, props), {}, {
      id: "ai",
      ref: ref,
      icon: element$c
    }));
  });
  AiIcon.displayName = "AiIcon";
  var AiIcon$1 = AiIcon;

  function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$b = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/bigdata.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var BigdataIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$b(_objectSpread$b({}, props), {}, {
      id: "bigdata",
      ref: ref,
      icon: element$b
    }));
  });
  BigdataIcon.displayName = "BigdataIcon";
  var BigdataIcon$1 = BigdataIcon;

  function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$a = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/compute.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var ComputeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$a(_objectSpread$a({}, props), {}, {
      id: "compute",
      ref: ref,
      icon: element$a
    }));
  });
  ComputeIcon.displayName = "ComputeIcon";
  var ComputeIcon$1 = ComputeIcon;

  function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$9 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/database.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var DatabaseIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$9(_objectSpread$9({}, props), {}, {
      id: "database",
      ref: ref,
      icon: element$9
    }));
  });
  DatabaseIcon.displayName = "DatabaseIcon";
  var DatabaseIcon$1 = DatabaseIcon;

  function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$8 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/developer_services.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var DeveloperServicesIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$8(_objectSpread$8({}, props), {}, {
      id: "developer_services",
      ref: ref,
      icon: element$8
    }));
  });
  DeveloperServicesIcon.displayName = "DeveloperServicesIcon";
  var DeveloperServicesIcon$1 = DeveloperServicesIcon;

  function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$7 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/enterprise_applications.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var EnterpriseApplicationsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$7(_objectSpread$7({}, props), {}, {
      id: "enterprise_applications",
      ref: ref,
      icon: element$7
    }));
  });
  EnterpriseApplicationsIcon.displayName = "EnterpriseApplicationsIcon";
  var EnterpriseApplicationsIcon$1 = EnterpriseApplicationsIcon;

  function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$6 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/essentials.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var EssentialsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$6(_objectSpread$6({}, props), {}, {
      id: "essentials",
      ref: ref,
      icon: element$6
    }));
  });
  EssentialsIcon.displayName = "EssentialsIcon";
  var EssentialsIcon$1 = EssentialsIcon;

  function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$5 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/game.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var GameIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$5(_objectSpread$5({}, props), {}, {
      id: "game",
      ref: ref,
      icon: element$5
    }));
  });
  GameIcon.displayName = "GameIcon";
  var GameIcon$1 = GameIcon;

  function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$4 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/internet_of_things.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var InternetOfThingsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$4(_objectSpread$4({}, props), {}, {
      id: "internet_of_things",
      ref: ref,
      icon: element$4
    }));
  });
  InternetOfThingsIcon.displayName = "InternetOfThingsIcon";
  var InternetOfThingsIcon$1 = InternetOfThingsIcon;

  function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$3 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/other.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var OtherIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$3(_objectSpread$3({}, props), {}, {
      id: "other",
      ref: ref,
      icon: element$3
    }));
  });
  OtherIcon.displayName = "OtherIcon";
  var OtherIcon$1 = OtherIcon;

  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$2 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/security.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var SecurityIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$2(_objectSpread$2({}, props), {}, {
      id: "security",
      ref: ref,
      icon: element$2
    }));
  });
  SecurityIcon.displayName = "SecurityIcon";
  var SecurityIcon$1 = SecurityIcon;

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element$1 = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/storage.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var StorageIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread$1(_objectSpread$1({}, props), {}, {
      id: "storage",
      ref: ref,
      icon: element$1
    }));
  });
  StorageIcon.displayName = "StorageIcon";
  var StorageIcon$1 = StorageIcon;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var element = {
    "tag": "div",
    "attrs": {
      "width": "1em",
      "height": "1em",
      "background": "url(https://ixd-icons.pages.woa.com/img/video.png)"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor"
      }
    }]
  };
  var VideoIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(IconBase, _objectSpread(_objectSpread({}, props), {}, {
      id: "video",
      ref: ref,
      icon: element
    }));
  });
  VideoIcon.displayName = "VideoIcon";
  var VideoIcon$1 = VideoIcon;

  exports.AiIcon = AiIcon$1;
  exports.AnalystReportIcon = AnalystReportIcon$1;
  exports.AvatarIcon = AvatarIcon$1;
  exports.BigdataIcon = BigdataIcon$1;
  exports.CalculatorIcon = CalculatorIcon$1;
  exports.ClickIcon = ClickIcon$1;
  exports.CloseIcon = CloseIcon$1;
  exports.ComputeIcon = ComputeIcon$1;
  exports.ContactSalesIcon = ContactSalesIcon$1;
  exports.ContactUsIcon = ContactUsIcon$1;
  exports.DatabaseIcon = DatabaseIcon$1;
  exports.DeveloperServicesIcon = DeveloperServicesIcon$1;
  exports.DisableIcon = DisableIcon$1;
  exports.DownIcon = DownIcon$1;
  exports.DownloadIcon = DownloadIcon$1;
  exports.EnterIcon = EnterIcon$1;
  exports.EnterpriseApplicationsIcon = EnterpriseApplicationsIcon$1;
  exports.ErrorIcon = ErrorIcon$1;
  exports.EssentialsIcon = EssentialsIcon$1;
  exports.FacebookIcon = FacebookIcon$1;
  exports.FacebookOIcon = FacebookOIcon$1;
  exports.FoldIcon = FoldIcon$1;
  exports.GameIcon = GameIcon$1;
  exports.GlobalIcon = GlobalIcon$1;
  exports.HoverIcon = HoverIcon$1;
  exports.Icon = Icon;
  exports.IconBase = IconBase$1;
  exports.IconFont = IconFont;
  exports.InfoIcon = InfoIcon$1;
  exports.InsightsIcon = InsightsIcon$1;
  exports.InternetOfThingsIcon = InternetOfThingsIcon$1;
  exports.LanguageIcon = LanguageIcon$1;
  exports.LeftIcon = LeftIcon$1;
  exports.LinkedinIcon = LinkedinIcon$1;
  exports.LinkedinOIcon = LinkedinOIcon$1;
  exports.LocationIcon = LocationIcon$1;
  exports.MenuIcon = MenuIcon$1;
  exports.MenuSubIcon = MenuSubIcon$1;
  exports.MouseIcon = MouseIcon$1;
  exports.NotAllSelectedIcon = NotAllSelectedIcon$1;
  exports.NotifyIcon = NotifyIcon$1;
  exports.NumEightIcon = NumEightIcon$1;
  exports.NumFiveIcon = NumFiveIcon$1;
  exports.NumFourIcon = NumFourIcon$1;
  exports.NumNineIcon = NumNineIcon$1;
  exports.NumOneIcon = NumOneIcon$1;
  exports.NumSevenIcon = NumSevenIcon$1;
  exports.NumSixIcon = NumSixIcon$1;
  exports.NumTwoIcon = NumTwoIcon$1;
  exports.NumZeroIcon = NumZeroIcon$1;
  exports.OtherIcon = OtherIcon$1;
  exports.PlayerIcon = PlayerIcon$1;
  exports.PressCenterIcon = PressCenterIcon$1;
  exports.ProductUpdatesIcon = ProductUpdatesIcon$1;
  exports.RadioDisableIcon = RadioDisableIcon$1;
  exports.RadioHoverIcon = RadioHoverIcon$1;
  exports.RadioSelectedDisableIcon = RadioSelectedDisableIcon$1;
  exports.RadioSelectedIcon = RadioSelectedIcon$1;
  exports.RadioUnselectedIcon = RadioUnselectedIcon$1;
  exports.RightIcon = RightIcon$1;
  exports.SearchIcon = SearchIcon$1;
  exports.SecurityIcon = SecurityIcon$1;
  exports.SelectedDisableIcon = SelectedDisableIcon$1;
  exports.SelectedIcon = SelectedIcon$1;
  exports.StorageIcon = StorageIcon$1;
  exports.SuccessIcon = SuccessIcon$1;
  exports.SuccessOIcon = SuccessOIcon$1;
  exports.ThreeIcon = ThreeIcon$1;
  exports.TwitterIcon = TwitterIcon$1;
  exports.TwitterOIcon = TwitterOIcon$1;
  exports.UnfoldIcon = UnfoldIcon$1;
  exports.UnselectedIcon = UnselectedIcon$1;
  exports.UpIcon = UpIcon$1;
  exports.VideoIcon = VideoIcon$1;
  exports.WarningIcon = WarningIcon$1;
  exports.WebinarIcon = WebinarIcon$1;
  exports.WechatIcon = WechatIcon$1;
  exports.WhitepaperIcon = WhitepaperIcon$1;
  exports.manifest = manifest;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map
